/**
 * Fonctions de formatage pures (format français : euros, dates, quantités).
 */

/** Formate un entier avec séparateur de milliers (espace insécable fine). Ex: 1 382. */
export function formatInt(n) {
  if (n === null || n === undefined) return '—';
  return Math.round(n).toLocaleString('fr-FR').replace(/\u202f|\u00a0/g, ' ');
}

/** Formate un montant en euros, format français. Ex: 14,50 € ou 42 €. */
export function formatEuro(n, { decimals } = {}) {
  if (n === null || n === undefined || n === '') return '—';
  const hasCents = decimals !== undefined ? decimals > 0 : !Number.isInteger(n);
  const s = Number(n).toLocaleString('fr-FR', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).replace(/\u202f|\u00a0/g, ' ');
  return `${s} €`;
}

/** Convertit une date ISO en JJ/MM/AAAA. */
export function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/** Heure HH:MM d'une date ISO. */
export function formatTime(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

/** Libellé relatif court pour le journal (aujourd'hui = heure, sinon jour abrégé). */
export function formatMovementTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  if (d.toDateString() === now.toDateString()) return formatTime(iso);
  const days = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'];
  return days[d.getDay()];
}

/** Quantité signée avec + explicite. Ex: +36, −1 (vrai signe moins). */
export function formatSigned(n) {
  if (n === 0) return '±0';
  return n > 0 ? `+${n}` : `−${Math.abs(n)}`;
}

/** Date longue du jour en majuscules. Ex: LUNDI 28 SEPTEMBRE. */
export function longDateUpper(date = new Date()) {
  return date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).toUpperCase();
}
